import axios from 'axios'
import qs from 'qs'
import { Toast } from 'vant'
const DOMAIN = 'https://bshszh-api.baoshanhszh.cn/'
// const DOMAIN = 'http://localhost:9999/'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'

axios.interceptors.request.use(function (config) {
    return config
}, function (error) {
    return Promise.reject(error)
});
// 响应拦截器即异常处理
axios.interceptors.response.use(response => {
    return response
}, err => {
    return Promise.resolve(err.response)
})

export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(DOMAIN + url, {
            params: params
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}

export function post(url, params) {
    let obj = {
        ...params
    };
    // axios.defaults.withCredentials = true;
    return new Promise((resolve, reject) => {
        axios.post(DOMAIN + url, qs.stringify(obj))
            .then(res => {
                if (res.data.status == 'ok') {
                    resolve(res.data)
                } else {
                    Toast(res.data.msg)

                    // 如果是token失效 跳转授权页面
                    if (res.data.error == "token failed") {

                        window.location.href = '/login'
                    }

                }
            })
            .catch(err => {
                reject(err.data)
            })
    })

}